import { render, staticRenderFns } from "./DataExportsPage.vue?vue&type=template&id=0efcbdf2&scoped=true&"
import script from "./DataExportsPage.vue?vue&type=script&lang=ts&"
export * from "./DataExportsPage.vue?vue&type=script&lang=ts&"
import style0 from "./DataExportsPage.vue?vue&type=style&index=0&id=0efcbdf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efcbdf2",
  null
  
)

export default component.exports